import {
  Autocomplete,
  FormControl,
  FormGroup,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import { User } from "../../app/backendTypes";
import { useAppSelector } from "../../app/hooks";

function EmployeePicker(props: {
  onChange: (val: User | null) => void;
  initialValue?: number | undefined;
  onLoad?: (value: User | null) => void;
}) {
  const { onChange, initialValue, onLoad } = props;

  const employees = useAppSelector((state) => state.employees.items);

  const value = employees.find((e) => e.employee.id === initialValue);

  useEffect(() => {
    if (value) onLoad && onLoad(value);
  }, [onLoad, value]);

  return (
    <FormControl fullWidth sx={{ maxWidth: "sm" }}>
      <FormGroup>
        <Autocomplete
          value={value || null}
          options={employees}
          getOptionLabel={(user) => user.employee.username}
          renderOption={(props, user) => (
            <Typography {...props}>{user.employee.username}</Typography>
          )}
          renderInput={(params) => (
            <TextField {...params} placeholder="Pick an employee" />
          )}
          onChange={(_, value) => onChange(value)}
        />
      </FormGroup>
    </FormControl>
  );
}

export default EmployeePicker;
